export default {
  cashbox: { 
    path: '/cashbox', 
    title: {
      ru: 'Касса',
      ua: 'Каса',
    },auth: true },
  cashboxWthdrawal: { path: '/cashbox/withdrawal', auth: true },
  cashboxDeposit: { path: '/cashbox/deposit', auth: true },
  cashboxHistory: { path: '/cashbox/history', auth: true },
  cashboxPayoutSuccess: { path: '/cashbox/payout-success', auth: true },
  cashboxPayoutError: { path: '/cashbox/payout-error', auth: true },
  cashboxPayinExt: { path: '/cashbox/payin-status-ext', auth: true },
  cashboxPayinError: { path: '/cashbox/payin-error', auth: true },
  cashboxPayinSuccess: { path: '/cashbox/payin-success', auth: true },
  cashboxSupport: { path: '/cashbox/support', auth: true },
}
